<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="scratchCardData === null">Create Scratch Card</span>
      <span v-else>Update Scratch Card</span>
    </h6>

    <form id="form-proper">
      <a-tabs default-active-key="scratch-card-details">
        <a-tab-pane key="scratch-card-details" tab="Scratch Card Details">
          <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
            <div class="row">
              <div class="col">
                <base-input label="Game Code" required>
                  <a-input
                    v-model.trim="$v.formData.game_code.$model"
                    :disabled="viewMode || scratchCardData != null"
                  />
                  <div v-if="$v.formData.game_code.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.game_code.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Name" required>
                  <a-input
                    v-model.trim="$v.formData.name.$model"
                    :disabled="
                      viewMode ||
                      (scratchCardData != null && scratchCardData.status == 'C')
                    "
                  />
                  <div v-if="$v.formData.name.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.name.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Description" required>
                  <a-input
                    v-model.trim="$v.formData.description.$model"
                    :disabled="
                      viewMode ||
                      (scratchCardData != null && scratchCardData.status == 'C')
                    "
                  />
                  <div
                    v-if="$v.formData.description.$dirty"
                    class="text-danger"
                  >
                    <div class="error" v-if="!$v.formData.description.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Membership Program" required>
                  <a-select
                    show-search
                    v-model="formData.membership_program_id"
                    :disabled="
                      viewMode ||
                      (scratchCardData != null &&
                        (scratchCardData.status == 'A' ||
                          scratchCardData.status == 'C'))
                    "
                    optionFilterProp="children"
                  >
                    <a-select-option
                      v-for="membershipProgram in membershipPrograms"
                      v-bind:value="membershipProgram.id"
                      v-bind:key="membershipProgram.id"
                    >
                      {{ membershipProgram.name }}
                    </a-select-option>
                  </a-select>
                  <div
                    v-if="$v.formData.membership_program_id.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.membership_program_id.required"
                    >
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input
                  label="Status"
                  required
                  :description="'Status will change base on Game Period.'"
                >
                  <a-select v-model="$v.formData.status.$model" disabled>
                    <a-select-option
                      v-for="status in options.status"
                      v-bind:value="status.key"
                      v-bind:key="status.key"
                    >
                      {{ status.name }}
                    </a-select-option>
                  </a-select>
                  <div v-if="$v.formData.status.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.status.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Game Period" required>
                  <br />
                  <a-range-picker
                    v-model="startEndDateRange"
                    :default-value="[formData.start_date, formData.end_date]"
                    :format="dateFormat"
                    @change="dateRangeOnChange"
                    style="width: 100%"
                    :disabled="
                      viewMode ||
                      (scratchCardData != null && scratchCardData.status == 'C')
                    "
                  />
                  <div v-if="$v.formData.start_date.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.start_date.required">
                      Start date is required
                    </div>
                  </div>
                  <div v-if="$v.formData.end_date.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.end_date.required">
                      End date is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <label for="playing_mechanics"><b>Playing Mechanics</b></label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Frequency" required>
                  <a-select
                    v-model="$v.formData.frequency_code.$model"
                    :disabled="
                      viewMode ||
                      (scratchCardData != null &&
                        (scratchCardData.status == 'A' ||
                          scratchCardData.status == 'C'))
                    "
                  >
                    <a-select-option
                      v-for="period in options.frequencies"
                      v-bind:value="period.code"
                      v-bind:key="period.code"
                    >
                      {{ period.name }}
                    </a-select-option>
                  </a-select>
                  <div
                    v-if="$v.formData.frequency_code.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.frequency_code.required"
                    >
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="form-control-label">
                  Game Image <span class="text-danger">*</span
                  ><small>(500x500px)</small></label
                >
                <div>
                  <b-form-file
                    v-if="!viewMode"
                    data-var-name="game_image_url"
                    @change="selectImage"
                    accept=".jpg, .jpeg, .png"
                    placeholder="Choose a file ..."
                    :disabled="
                      viewMode ||
                      (scratchCardData != null && scratchCardData.status == 'C')
                    "
                  ></b-form-file>
                  <div
                    v-if="$v.formData.game_image_url.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.game_image_url.required"
                    >
                      Field is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="formData.game_image_url">
              <div class="col">
                <base-input label="Image Preview: ">
                  <br />
                  <a-button
                    type="danger"
                    data-var-name="game_image_url"
                    @click="removeImage"
                    block
                    :disabled="
                      viewMode ||
                      formSubmitting ||
                      (scratchCardData != null && scratchCardData.status == 'C')
                    "
                  >
                    <i class="fa fa-trash"> </i> Remove Image
                  </a-button>
                  <br />
                  <img :src="formData.game_image_url" />
                </base-input>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col">
                <label class="form-control-label">
                  Top Image <span class="text-danger">*</span
                  ><small>(1528x1412px)</small></label
                >
                <div>
                  <b-form-file
                    v-if="!viewMode"
                    data-var-name="cover_image_url"
                    @change="selectImage"
                    accept=".jpg, .jpeg, .png"
                    placeholder="Choose a file ..."
                    :disabled="
                      viewMode ||
                      (scratchCardData != null && scratchCardData.status == 'C')
                    "
                  ></b-form-file>
                  <div
                    v-if="$v.formData.cover_image_url.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.cover_image_url.required"
                    >
                      Field is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="formData.cover_image_url">
              <div class="col">
                <base-input label="Image Preview: ">
                  <br />
                  <a-button
                    type="danger"
                    data-var-name="cover_image_url"
                    block
                    :disabled="
                      viewMode ||
                      formSubmitting ||
                      (scratchCardData != null && scratchCardData.status == 'C')
                    "
                    @click="removeImage"
                  >
                    <i class="fa fa-trash"> </i> Remove Image
                  </a-button>
                  <br />
                  <img :src="formData.cover_image_url" />
                </base-input>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="scratch-card-rewards" tab="Scratch Card Rewards">
          <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
            <div class="row">
              <div class="col">
                <div>
                  <h4>Guidelines for rewards:</h4>
                  <ul>
                    <li><b>CHANCE(%)</b> column should be add up to 100%.</li>
                    <li>
                      Enter <b>-1</b> for infinite <b>MAX NUMBER OF WINNER</b>.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <b-table
                  small
                  :fields="rewardTableFields"
                  :items="formData.rewards"
                  responsive="sm"
                >
                  <template #cell(actions)="codeRow">
                    <div>
                      <a-popconfirm
                        title="Are you sure you want to delete this reward?"
                        @confirm="() => deleteReward(codeRow, null)"
                      >
                        <a
                          style="color: white"
                          class="btn btn-sm btn-danger"
                          :disabled="
                            viewMode ||
                            (scratchCardData != null &&
                              scratchCardData.status == 'C')
                          "
                          >Delete</a
                        >
                      </a-popconfirm>
                    </div>
                  </template>
                  <template #cell(code)="codeRow">
                    <div class="row">
                      <div class="col">
                        <b-form-input
                          :disabled="
                            viewMode ||
                            (scratchCardData != null &&
                              scratchCardData.status == 'C')
                          "
                          :id="`rewardCode-${codeRow.index}`"
                          v-model="formData.rewards[codeRow.index].code"
                          aria-placeholder="Enter Code"
                          type="text"
                        ></b-form-input>
                        <div
                          v-if="
                            $v.formData.rewards.$each[codeRow.index].code.$dirty
                          "
                          class="text-danger"
                        >
                          <div
                            class="error"
                            v-if="
                              !$v.formData.rewards.$each[codeRow.index].code
                                .required
                            "
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(type)="typeRow">
                    <div class="row">
                      <div class="col">
                        <b-form-input
                          :id="`rewardType-${typeRow.index}`"
                          v-model="formData.rewards[typeRow.index].type"
                          defaultValue="points"
                          type="text"
                          disabled
                        ></b-form-input>
                        <div
                          v-if="
                            $v.formData.rewards.$each[typeRow.index].type.$dirty
                          "
                          class="text-danger"
                        >
                          <div
                            class="error"
                            v-if="
                              !$v.formData.rewards.$each[typeRow.index].type
                                .required
                            "
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(chance)="chanceRow">
                    <div class="row">
                      <div class="col">
                        <b-form-input
                          :disabled="
                            viewMode ||
                            (scratchCardData != null &&
                              scratchCardData.status == 'C')
                          "
                          :id="`rewardChance-${chanceRow.index}`"
                          v-model="formData.rewards[chanceRow.index].chance"
                          aria-placeholder="Enter Chance Percentage"
                          type="text"
                        ></b-form-input>
                        <div
                          v-if="
                            $v.formData.rewards.$each[chanceRow.index].chance
                              .$dirty
                          "
                          class="text-danger"
                        >
                          <div
                            class="error"
                            v-if="
                              !$v.formData.rewards.$each[chanceRow.index].chance
                                .required
                            "
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(points_earned)="pointEarnedRow">
                    <div class="row">
                      <div class="col">
                        <b-form-input
                          :disabled="
                            viewMode ||
                            (scratchCardData != null &&
                              scratchCardData.status == 'C')
                          "
                          :id="`rewardPointEarned-${pointEarnedRow.index}`"
                          v-model="
                            formData.rewards[pointEarnedRow.index].points_earned
                          "
                          type="text"
                        ></b-form-input>
                        <div
                          v-if="
                            $v.formData.rewards.$each[pointEarnedRow.index]
                              .points_earned.$dirty
                          "
                          class="text-danger"
                        >
                          <div
                            class="error"
                            v-if="
                              !$v.formData.rewards.$each[pointEarnedRow.index]
                                .points_earned.required
                            "
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template #cell(max_number_of_winner)="maxNumberOfWinnerRow">
                    <div class="row">
                      <div class="col">
                        <b-form-input
                          :id="`rewardMaxWinner-${maxNumberOfWinnerRow.index}`"
                          v-model="
                            formData.rewards[maxNumberOfWinnerRow.index]
                              .max_number_of_winner
                          "
                          aria-placeholder="Enter Max Number of Winners"
                          type="text"
                          :disabled="
                            viewMode ||
                            (scratchCardData != null &&
                              (scratchCardData.status == 'A' ||
                                scratchCardData.status == 'C'))
                          "
                        ></b-form-input>
                        <div
                          v-if="
                            $v.formData.rewards.$each[
                              maxNumberOfWinnerRow.index
                            ].max_number_of_winner.$dirty
                          "
                          class="text-danger"
                        >
                          <div
                            class="error"
                            v-if="
                              !$v.formData.rewards.$each[
                                maxNumberOfWinnerRow.index
                              ].max_number_of_winner.required
                            "
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(text_display)="textDisplayRow">
                    <div class="row">
                      <div class="col">
                        <b-form-input
                          :id="`textDisplay-${textDisplayRow.index}`"
                          v-model="
                            formData.rewards[textDisplayRow.index].text_display
                          "
                          aria-placeholder="Text to display"
                          type="text"
                          :disabled="
                            viewMode ||
                            (scratchCardData != null &&
                              scratchCardData.status == 'C')
                          "
                        ></b-form-input>
                        <div
                          v-if="
                            $v.formData.rewards.$each[textDisplayRow.index]
                              .text_display.$dirty
                          "
                          class="text-danger"
                        >
                          <div
                            class="error"
                            v-if="
                              !$v.formData.rewards.$each[textDisplayRow.index]
                                .text_display.required
                            "
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(image)="imageRow">
                    <div
                      v-if="!formData.rewards[imageRow.index].image"
                      class="row"
                    >
                      <div class="col">
                        <div>
                          <b-form-file
                            v-if="!viewMode"
                            label-size="small"
                            placeholder=""
                            data-var-name="rewardImage"
                            :data-index="imageRow.index"
                            @change="assignRewardImage"
                            accept=".jpg, .jpeg, .png"
                            :disabled="
                              viewMode ||
                              (scratchCardData != null &&
                                scratchCardData.status == 'C')
                            "
                          ></b-form-file>
                          <div
                            v-if="
                              $v.formData.rewards.$each[imageRow.index].image
                                .$dirty
                            "
                            class="text-danger"
                          >
                            <div
                              class="error"
                              v-if="
                                !$v.formData.rewards.$each[imageRow.index].image
                                  .required
                              "
                            >
                              Field is required
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-if="formData.rewards[imageRow.index].image"
                    >
                      <div class="col">
                        <base-input>
                          <a-button
                            type="danger"
                            @click="removeRewardImage(imageRow.index)"
                            block
                            :disabled="
                              viewMode ||
                              formSubmitting ||
                              (scratchCardData != null &&
                                scratchCardData.status == 'C')
                            "
                          >
                            <i class="fa fa-trash"> </i> Remove Image
                          </a-button>
                          <br />
                          <img
                            :src="formData.rewards[imageRow.index].image"
                            style="width: 225px"
                          />
                        </base-input>
                      </div>
                    </div>
                  </template>

                  <template #custom-foot>
                    <b-tr>
                      <b-td colspan="4" class="text-center">
                        <b-button
                          size="sm"
                          style="margin-left: 8px"
                          @click.prevent="addReward"
                          :disabled="
                            viewMode ||
                            (scratchCardData != null &&
                              scratchCardData.status == 'C')
                          "
                        >
                          Add Reward
                        </b-button>
                      </b-td>
                    </b-tr>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>

      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="scratchCardData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createScratchCard"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-if="
                      scratchCardData != null && scratchCardData.status != 'C'
                    "
                    size="sm"
                    variant="primary"
                    @click.prevent="updateScratchCard"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import HTTPRequest from '../../controllers/httpRequest';
import moment from 'moment-timezone';
import axios from 'axios';
import secureStorage from '../../controllers/secureStorage';
import tokenHandler from '../../controllers/token';
import _ from 'lodash';
import { mapGetters } from 'vuex';

const S3Api = process.env.VUE_APP_CLP_S3_API;

export default {
  name: 'ScratchCardForm',
  props: {
    scratchCardData: Object,
    viewMode: Boolean
  },

  data() {
    return {
      originalStartDate: null,
      coverImage: null,
      coverImageFile: null,
      gameImage: null,
      gameImageFile: null,
      rewardImageFile: [],
      formSubmitting: false,
      rewardTableFields: [
        { key: 'actions', label: 'Actions' },
        { key: 'code', label: 'Code' },
        { key: 'type', label: 'Reward Type' },
        { key: 'chance', label: 'Chance(%)' },
        { key: 'points_earned', label: 'Points Earned' },
        { key: 'max_number_of_winner', label: 'Max Number of Winner' },
        { key: 'text_display', label: 'Text Display' },
        { key: 'image', label: 'Image(1528x1412px)' }
      ],
      dateFormat: 'YYYY-MM-DD',
      startEndDateRange: null,
      formData: {
        membership_program_id: null,
        game_type_code: 'SCR_CD',
        game_code: null,
        name: null,
        description: null,
        frequency_code: null,
        claim_limit: 1,
        status: 'A',
        cover_image_url: null,
        game_image_url: null,
        start_date: null,
        end_date: null,
        rewards: [
          {
            code: null,
            type: 'points',
            image: null,
            chance: null,
            points_earned: null,
            max_number_of_winner: null,
            number_of_winner: 0,
            text_display: null
          }
        ]
      },
      options: {
        frequencies: [],
        types: [],
        status: [
          { key: 'N', name: 'Not Started' },
          { key: 'A', name: 'Active' },
          { key: 'C', name: 'Completed' }
        ],
        periods: [
          { key: 'once', value: 'Once' },
          { key: 'hourly', value: 'Hourly' },
          { key: 'daily', value: 'Daily' },
          { key: 'weekly', value: 'Weekly' },
          { key: 'monthly', value: 'Monthly' }
        ]
      }
    };
  },

  validations: {
    formData: {
      game_code: { required },
      name: { required },
      description: { required },
      cover_image_url: { required },
      game_image_url: { required },
      frequency_code: { required },
      claim_limit: { required },
      status: { required },
      rewards: {
        $each: {
          code: { required },
          image: { required },
          chance: { required },
          points_earned: { required },
          max_number_of_winner: { required },
          type: { required },
          text_display: { required }
        }
      },
      start_date: { required },
      end_date: { required },
      membership_program_id: { required }
    }
  },

  methods: {
    moment,
    deleteReward(row) {
      if (this.formData.rewards.length == 1) {
        this.$notification.error({
          message: 'Cannot delete reward.'
        });
      } else {
        this.formData.rewards.splice(row.index, 1);
        this.rewardImageFile.splice(row.index, 1);
      }
    },
    addReward() {
      this.formData.rewards.push({
        code: null,
        type: 'points',
        image: null,
        chance: null,
        points_earned: null,
        max_number_of_winner: null,
        number_of_winner: 0,
        text_display: null
      });
    },
    async assignRewardImage(event) {
      const { index } = event.target.dataset;
      this.rewardImageFile[index] = [event.target.files[0]];
      const { src, width, height } = await this.readFileContent(
        event.target.files[0]
      );
      let w = 1528,
        h = 1412,
        imageType = 'Reward Image';
      if (w != width && h != height) {
        this.$message.error(`${imageType} should be ${w} x ${h} px. `);
      } else {
        this.formData.rewards[index].image = src;
      }
    },
    removeRewardImage(index) {
      delete this.rewardImageFile[index];
      this.formData.rewards[index].image = null;
    },
    async selectImage(event) {
      let varName, varNameCamelCase, fileHolder;
      varName = event.target.dataset.varName;
      varNameCamelCase = _.camelCase(varName.replace('_url', ''));
      fileHolder = `${varNameCamelCase}File`;

      this[fileHolder] = [event.target.files[0]];
      const { src, width, height } = await this.readFileContent(
        event.target.files[0]
      );
      console.log('width ', width);
      console.log('height ', height);
      let w = 0,
        h = 0,
        imageType;
      if (varName == 'game_image_url') {
        w = 500;
        h = 500;
        imageType = 'Game Image';
      }
      if (varName == 'cover_image_url') {
        w = 1528;
        h = 1412;
        imageType = 'Top Image';
      }

      if (w != width && h != height) {
        this.$message.error(`${imageType} should be ${w} x ${h} px. `);
      } else {
        this.formData[varName] = src;
      }
    },
    removeImage() {
      let varName, varNameCamelCase, fileHolder;
      varName = event.target.dataset.varName;
      varNameCamelCase = _.camelCase(varName.replace('_url', ''));
      fileHolder = `${varNameCamelCase}File`;
      this[fileHolder] = null;
      this.formData[varName] = null;
    },
    validateRewardTotal(rewards, total) {
      let x = 0,
        result = false,
        rewardPercentage = 0;
      while (x < rewards.length) {
        rewardPercentage = rewardPercentage + parseInt(rewards[x].chance);
        x++;
      }
      if (rewardPercentage == total) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    async createScratchCard() {
      this.$v.formData.$touch();
      const validTotal = this.validateRewardTotal(this.formData.rewards, 100);

      if (validTotal == false) {
        this.$notification.error({
          message:
            'The total percentage of reward chances should add up to 100%.'
        });
        return;
      }
      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;

        const coverImageS3Path = await this.s3Upload(this.coverImageFile);
        if (coverImageS3Path) {
          this.formData.cover_image_url = coverImageS3Path;
        } else {
          this.formData.cover_image_url = null;
        }
        const gameImageS3Path = await this.s3Upload(this.gameImageFile);
        if (gameImageS3Path) {
          this.formData.game_image_url = gameImageS3Path;
        } else {
          this.formData.game_image_url = null;
        }
        let rewardImageS3Path,
          x = 0;
        while (x < this.rewardImageFile.length) {
          rewardImageS3Path = await this.s3Upload(this.rewardImageFile[x]);
          if (rewardImageS3Path) {
            this.formData.rewards[x].image = rewardImageS3Path;
          } else {
            this.formData.rewards[x].image;
          }
          x++;
        }
        const response = await HTTPRequest.postRequest(
          '/api/v1/account_games',
          {
            account_game: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    async updateScratchCard() {
      this.$v.formData.$touch();
      const validTotal = this.validateRewardTotal(this.formData.rewards, 100);
      if (validTotal == false) {
        this.$notification.error({
          message:
            'The total percentage of reward chances should add up to 100%.'
        });
        return;
      }
      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;

        if (this.coverImageFile != null) {
          const coverImageS3Path = await this.s3Upload(this.coverImageFile);
          if (coverImageS3Path) {
            this.formData.cover_image_url = coverImageS3Path;
          } else {
            this.formData.cover_image_url = null;
          }
        }
        if (this.gameImageFile != null) {
          const gameImageS3Path = await this.s3Upload(this.gameImageFile);
          if (gameImageS3Path) {
            this.formData.game_image_url = gameImageS3Path;
          } else {
            this.formData.game_image_url = null;
          }
        }
        if (this.rewardImageFile.length > 0) {
          let rewardImageS3Path,
            x = 0;
          while (x < this.rewardImageFile.length) {
            if (this.rewardImageFile[x] != undefined) {
              rewardImageS3Path = await this.s3Upload(this.rewardImageFile[x]);
              if (rewardImageS3Path) {
                this.formData.rewards[x].image = rewardImageS3Path;
              } else {
                this.formData.rewards[x].image;
              }
            }
            x++;
          }
        }
        const response = await HTTPRequest.putRequest(
          '/api/v1/account_games/' + this.scratchCardData.id,
          {
            account_game: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    dateRangeOnChange(dateObj, dateString) {
      if (this.scratchCardData != null && this.formData.status == 'A') {
        if (dateString[0] != this.originalStartDate) {
          dateString[0] = this.originalStartDate;
          this.$notification.info({
            message: 'Cannot update start date. Set to original start date.'
          });
        }
      }
      this.startEndDateRange = dateString;
      this.formData.start_date = dateString[0] ?? null;
      this.formData.end_date = dateString[1] ?? null;
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },

    clearForm() {
      this.coverImageFile = null;
      this.rewardImageFile = [];
      this.formData = {
        game_type_code: 'SCR_CD',
        game_code: null,
        name: null,
        description: null,
        frequency_code: null,
        claim_limit: 1,
        status: 'A',
        cover_image_url: null,
        membership_program_id: null,
        rewards: [
          {
            code: null,
            type: 'points',
            image: null,
            chance: null,
            points_earned: null,
            max_number_of_winner: null,
            number_of_winner: 0,
            text_display: null
          }
        ]
      };
    },
    setFormData(data) {
      if (data !== null) {
        const {
          game_code,
          name,
          description,
          game_type_code,
          frequency_code,
          claim_limit,
          cover_image_url,
          game_image_url,
          rewards,
          status,
          start_date,
          end_date,
          membership_program_id
        } = data;
        console.log('membership_program_id ', membership_program_id);
        const startDate = moment(start_date)
          .tz(moment.tz.guess())
          .format(this.dateFormat);
        const endDate = moment(end_date)
          .tz(moment.tz.guess())
          .format(this.dateFormat);

        this.formData = {
          game_code,
          name,
          description,
          game_type_code,
          frequency_code,
          claim_limit,
          cover_image_url,
          game_image_url,
          rewards: [],
          status,
          start_date: startDate,
          end_date: endDate,
          membership_program_id
        };

        this.startEndDateRange = [startDate, endDate];

        let x = 0;
        while (x < rewards.length) {
          let reward = rewards[x];
          if (Number.isNaN(reward.number_of_winner)) {
            reward.number_of_winner = 0;
          }
          if (reward.number_of_winner == undefined) {
            reward.number_of_winner = 0;
          }
          if (rewards.text_display == undefined) {
            rewards.text_display = null;
          }
          this.formData.rewards.push(reward);
          x++;
        }
        if (status == 'A') {
          this.originalStartDate = startDate;
        }
      }
    },
    // upload image functions

    async beforeUpload(file) {
      // Check file type
      const isJpgOrPng =
        file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload .jpeg or .png file!');
        return false;
      }

      // Check if filesize is > (n)mb
      // const fileSize = file.size / 1024 / 1024 < this.maxFileSize;
      // if (!fileSize) {
      //   this.$message.error('Image must smaller than 2MB!');
      //   return false;
      // }
      return false;
    },
    handleRemove() {
      this.imgPreview = null;
      this.fileList = [];
      this.formData.image = null;
    },

    async s3Upload(file = [], firstTry = true) {
      if (file.length > 0) {
        console.log('Uploading to S3');
        const formData = new FormData();
        formData.append('file', file[0]);

        let filePath = null;
        try {
          const upload = await axios({
            method: 'POST',
            url:
              S3Api +
              '?account_name=' +
              this.accountName +
              '&profile=scratch-games-images',
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem('uploadToken')
            },
            data: formData
          });

          if (typeof upload.data.path !== 'undefined' && upload.data.path) {
            console.log('File uploaded');
            filePath = upload.data.path;
          } else {
            console.log('No upload path');
            this.$message.error('Unable to upload image. Please try again!');
          }

          return filePath;
        } catch (err) {
          let retries = 3;
          let isReloggedIn = false;
          const responseStatus = err.response.status;
          if (responseStatus === 401 && firstTry) {
            while (!isReloggedIn && retries > 0) {
              try {
                isReloggedIn = await tokenHandler.refreshS3Token();
              } catch (err) {
                console.log('Failed to refresh token');
              } finally {
                retries--;
                this.$message.info('Retrying to upload image!');
              }
            }
            if (isReloggedIn) {
              return this.s3Upload(file, false);
            }
          }
          this.$message.error('Unable to upload image. Something went wrong!');
          throw err;
        }
      }

      return null;
    },

    readFileContent(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let img = new Image();
          img.src = evt.target.result;
          img.onload = function () {
            resolve({
              src: img.src,
              width: img.width,
              height: img.height
            });
          };
        };
        reader.onerror = reject;
      });
    },
    async fetchGameFrequencies() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/games/frequencies'
      );
      this.options.frequencies = response;
    },
    async fetchGameTypes() {
      const response = await HTTPRequest.getRequest('/api/v1/games/types');
      this.options.types = response;
    },
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.defaultMembershipProgram = response.data[0];
      this.options.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    }
  },
  created: async function () {
    await this.fetchGameFrequencies();
    // await this.getMembershipPrograms();
    // this.fetchGameTypes();
  },
  mounted() {
    this.setFormData(this.scratchCardData);
  },
  computed: {
    accountName() {
      return this.$store.getters.getAccount?.account_name ?? null;
    },
    ...mapGetters({
      membershipPrograms: 'membershipPrograms'
    })
  },
  watch: {
    'formData.duration': function (val) {
      if (val == 'once') {
        this.formData.duration_limit = 'once';
      } else {
        this.formData.duration_limit = 1;
      }
    },
    scratchCardData: function (newVal) {
      if (newVal !== null) {
        this.setFormData(newVal);
      } else {
        this.clearForm();
      }
    }
  }
};
</script>

<style scoped></style>
